import { ECheckServiceErrorCode } from '../../types/reducers/checkoutInfo';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHECK_SERVICE_FAIL = 'CHECKOUT_INFO :: CHECK_SERVICE_FAIL';

export type TCheckServiceFailAction = IReduxAction<typeof CHECK_SERVICE_FAIL, ECheckServiceErrorCode>;

export const checkServiceFail = actionGenerator<typeof CHECK_SERVICE_FAIL, ECheckServiceErrorCode>(CHECK_SERVICE_FAIL);
